var parser = require('../formatters/key-points-parser');

// PROFCORE-34854: reasons for the Key Points feedback drawer — differs from html.js's list.
var KEY_POINTS_FEEDBACK_REASONS = [
    'Factual inaccuracy',
    'Omitted key information',
    'Oversimplified information',
    'Language/grammar issues',
    'Irrelevant follow up questions',
    'Other'
];

var CHECKMARK_SVG = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<path fill-rule="evenodd" clip-rule="evenodd" d="M15.8536 2.14643C16.0488 2.34169 16.0488 2.65828 15.8536 2.85354L5.20711 13.5C4.81658 13.8905 4.18342 13.8905 3.79289 13.5L0.146447 9.85354C-0.0488155 9.65828 -0.0488155 9.34169 0.146447 9.14643C0.341709 8.95117 0.658291 8.95117 0.853553 9.14643L4.5 12.7929L15.1464 2.14643C15.3417 1.95117 15.6583 1.95117 15.8536 2.14643Z" fill="#064AA7"/>' +
    '</svg>';

function articleInlineKeyPointsCard(bullets , keyPointTitle) {
    var bulletsHtml = bullets.map(function(bullet) {
        // Apply bold/italic formatting — shared via key-points-parser
        var formattedBullet = parser.formatKeyPointText(bullet);
        return '<li class="key-points-bullet">' + formattedBullet + '</li>';
    }).join('');

    return '<div class="key-points-card" id="key-points-card">' +
               '<div class="key-points-header">' +
                   '<div class="key-points-title-container">' +                       
                       '<div class="key-points-title">'+ keyPointTitle +'</div>' +
                   '</div>' +                  
               '</div>' +
               '<div class="key-points-content">' +
                   '<ul class="conditions-key-points-list">' +
                       bulletsHtml +
                   '</ul>' +
               '</div>' +
           '</div>';
}

function articleInlineFollowUpQuestionsTemplate(questions) {
    var questionsHtml = questions.map(function(question, idx) {
        return '<div class="inline-follow-up-item" tabindex="0" role="button"' +
                   ' aria-label="Follow-up question: ' + question + '"' +
                   ' data-question="' + question + '"' +
                   ' data-index="' + (idx + 1) + '">' +
                   '<span class="ai-sparkle"></span>' +
                   '<span class="inline-follow-up-text">' + question + '</span>' +
               '</div>';
    }).join('');

    return '<div class="inline-follow-up-list">' + questionsHtml + '</div>';
}

// Static Deep Dive options rendered as pills. The visible label is link.text; the query
// submitted on click is link.prompt (carried in data-prompt). Click behavior is wired via
// event delegation in bindui.js (.deep-dive-pill) and mirrors the existing Deep Dive.
function articleInlineDeepDivePillsTemplate(links) {
    var pillsHtml = links.map(function(link, idx) {
        var prompt = String(link.prompt).replace(/"/g, '&quot;');
        return '<button type="button" class="deep-dive-pill"' +
                   ' data-prompt="' + prompt + '"' +
                   ' data-link-id="' + link.id + '"' +
                   ' data-index="' + (idx + 1) + '">' +
                   link.text +
               '</button>';
    }).join('');

    return '<div class="deep-dive-pills">' + pillsHtml + '</div>';
}

// PROFCORE-34854: thumbs up/down widget for Condition pages. Distinct classes from the
// modal's `.ai-search-rating` so its listeners/CSS can't pick this up.
function keyPointsRatingTemplate() {
    return '<div class="key-points-rating">' +
               '<span class="key-points-like" role="button" tabindex="0" aria-label="Like Key Points" aria-pressed="false">' +
                   '<span class="key-points-rating-icon"></span>' +
                   '<span class="key-points-rating-text">Helpful</span>' +
               '</span>' +
               '<span class="key-points-dislike" role="button" tabindex="0" aria-label="Dislike Key Points" aria-pressed="false">' +
                   '<span class="key-points-rating-icon"></span>' +
                   '<span class="key-points-rating-text">Not Helpful</span>' +
               '</span>' +
           '</div>';
}

// PROFCORE-34854: standalone dislike-feedback dialog, appended to document.body — a
// fixed centered overlay, not the modal's bottom-sheet #feedbackDrawer.
function keyPointsFeedbackDrawerTemplate() {
    var optionsHtml = KEY_POINTS_FEEDBACK_REASONS.map(function(reason) {
        var isOther = reason === 'Other';
        return '<label class="key-points-feedback-option">' +
                   '<input type="checkbox" name="kp-reason" value="' + reason + '"' + (isOther ? ' id="keyPointsOtherCheckbox"' : '') + '>' +
                   '<span class="checkmark">' + CHECKMARK_SVG + '</span>' +
                   '<span class="key-points-feedback-option-text">' + reason + '</span>' +
               '</label>';
    }).join('');

    return '<div id="keyPointsFeedbackDrawer" class="key-points-feedback-drawer">' +
               '<div class="key-points-feedback-overlay"></div>' +
               '<div class="key-points-feedback-dialog">' +
                   '<span class="key-points-feedback-close-btn" aria-label="Close feedback dialog" role="button" tabindex="0"></span>' +
                   '<div id="keyPointsFeedbackSuccessMsg"><p>Thank you for providing your feedback!</p></div>' +
                   '<h3 id="keyPointsFeedbackTitle">Medscape AI Feedback</h3>' +
                   '<p class="key-points-feedback-intro">Please select the reason(s) for your feedback:</p>' +
                   '<form id="keyPointsFeedbackForm" class="key-points-feedback-checkbox-group">' +
                       optionsHtml +
                       '<textarea id="keyPointsOtherText" rows="3" placeholder="Please provide additional details"></textarea>' +
                       '<div class="key-points-divider" role="separator"></div>' +
                       '<div class="key-points-feedback-btn-row">' +
                           '<button type="button" class="key-points-feedback-cancel-btn">Close</button>' +
                           '<button type="submit" class="key-points-feedback-submit-btn">Submit Feedback</button>' +
                       '</div>' +
                   '</form>' +
               '</div>' +
           '</div>';
}

module.exports = {
    articleInlineKeyPointsCard: articleInlineKeyPointsCard,
    articleInlineFollowUpQuestionsTemplate: articleInlineFollowUpQuestionsTemplate,
    articleInlineDeepDivePillsTemplate: articleInlineDeepDivePillsTemplate,
    keyPointsRatingTemplate: keyPointsRatingTemplate,
    keyPointsFeedbackDrawerTemplate: keyPointsFeedbackDrawerTemplate
};
